<script setup lang="ts">
import BrandLogo from "./BrandLogo.vue";
</script>

<template>
  <header class="border-b border-app-border bg-app-shell/60 backdrop-blur-md">
    <div class="mx-auto flex max-w-6xl items-center justify-center gap-6 px-6 py-4">
      <BrandLogo class="h-24 w-auto shrink-0 md:h-32" />
    </div>
  </header>
</template>
